import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const ButtonPrint = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: none;
  border: none;
  width: 100%;
  padding: 0;
  text-align: left;
  gap: 0.2rem;
`;

export const ContainerComponentToPrint = styled.div`
  display: none;

  @media print {
    display: block;
  }
`;
